import { headerHeight, subheaderHeight } from '@creditsights/styleguide-web';
import { useEffect, useState } from 'react';
import useWindowResizeListener from '../common/useWindowResizeListener';
import { useIntersectionObserver } from './index';

const threshold = Array.from(Array(100), (_, i) => i / 100); // list of thresholds to ensure content height changes are observed

export default (withSubheader?: boolean, offset = 0): number => {
  const [height, setHeight] = useState<number>(0);
  const footer = document.querySelector('.footer-body');
  const footerEntry = useIntersectionObserver(footer, {
    threshold,
  });
  const subheaderImpact = withSubheader ? subheaderHeight : 0;
  const setCalculatedHeight = () => {
    const visibleFooterFraction = (footer && Math.max(0, window.innerHeight - footer.getBoundingClientRect().top)) || 0;
    setHeight(window.innerHeight - offset - visibleFooterFraction - headerHeight - subheaderImpact);
  };

  useWindowResizeListener(setCalculatedHeight);

  useEffect(() => {
    setCalculatedHeight();
  }, [footerEntry]);

  return height;
};
